import { Form } from "react-bootstrap";
import * as React from "react";
import UserSelectorOption from "./UserSelectorOption";

export default ({ options, label, onChange }) => (
    <Form.Control as="select" onChange={onChange}>
        <option key="" value="">{label}</option>
        {options.map(option => <UserSelectorOption key={option.userId} option={option}/>)}
    </Form.Control>
);